import { Icon, Tooltip } from '@components/ui';
import { useApi } from '@data-access';
import { MapperHelper } from '@helpers';
import { AuthorizationContext } from '@providers';
import { NotificationsPopup } from '@sections/NotificationsPopup/NotificationsPopup';
import { notificationsStore, userStore } from '@stores';
import { AppRoutes } from '@types';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import CalvinLogo from 'public/logo/calvinrisk logo.svg';
import React, { useCallback, useContext, useEffect, useState } from 'react';

import { getProfileLinks } from './Navbar.mocks';
import styles from './Navbar.module.scss';

export const Navbar = observer(() => {
  const { pathname, push } = useRouter();
  const { accounts } = useApi();
  const { logout } = useContext(AuthorizationContext);

  const { unreadNotificationsCount } = notificationsStore;
  const { user, setUser } = userStore;

  const [showNotifications, setShowNotifications] = useState<boolean>(false);

  const isSelecectedUserProfile = pathname?.endsWith(AppRoutes.userProfile);
  const content = getProfileLinks(logout).map(item => (
    <div
      key={item.href}
      className={clsx(styles.subitem, {
        [styles.selectedSubitem]: pathname?.endsWith(`/${item.href.split('/').pop()}`),
      })}
      onClick={() => {
        push(item.href);
        item.onClick();
      }}
    >
      <div className={clsx(styles.sidebarSubItem)}>{item.icon}</div>
      <Link href={item.href}>{item.label}</Link>
    </div>
  ));

  const fetchUserInfo = useCallback(async () => {
    const fetchedUserInfo = await accounts.accountsCalvinuserList();
    setUser(fetchedUserInfo.results[0]);
  }, [accounts, setUser]);

  useEffect(() => {
    fetchUserInfo();
  }, [fetchUserInfo]);

  return (
    <nav className={styles.navbar}>
      <Link
        href={`${AppRoutes.dashboard}`}
        className="space-x-8 flex py-4"
      >
        <CalvinLogo />
      </Link>
      <div className={clsx(styles.rightDiv)}>
        <div className={styles.navItem}>
          <Icon
            name="bell"
            data-notification
            className={clsx(styles.navbarIcon, styles.notification)}
            onClick={() => setShowNotifications(prev => !prev)}
          />
          {unreadNotificationsCount > 0 && (
            <div
              data-notification
              className={styles.indicator}
              onClick={() => setShowNotifications(prev => !prev)}
            >
              {unreadNotificationsCount}
            </div>
          )}
          <NotificationsPopup
            isOpen={showNotifications}
            setIsOpen={setShowNotifications}
          />
        </div>
        <Tooltip
          className={styles.tooltip}
          placement="bottom-end"
          content={content}
          hideArrow
        >
          <div className={clsx(styles.navItem, { [styles.activeNavItem]: isSelecectedUserProfile })}>
            <div className={styles.userAvatar}>
              {user?.calvinProfile?.profileImage ? (
                <Image
                  src={user?.calvinProfile.profileImage}
                  alt="User Avatar"
                  width="200"
                  height="300"
                />
              ) : (
                <div className={styles.initials}>{MapperHelper.getInitials(user.username)}</div>
              )}
            </div>
          </div>
        </Tooltip>
      </div>

      {/* <input
      type="text"
      className="block p-1 pl-10 w-70 text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:pl-3"
      placeholder="Search Calvin"
    /> */}
    </nav>
  );
});
